// calls-delete-gate-v1
//
// Owner-reported bug (2026-07-06): logged in as Leo Citrangulo (role
// Estimator), the #/calls list let him select all 200 rows and showed a
// working Delete action in the selection bar — calls must NEVER be
// deletable by regular users, only admins, and the real gate must be
// server-side (fail closed) with the UI affordance also hidden for
// non-admins (docs/REGRESSIONS.md).
//
// This pure, framework-agnostic helper mirrors the backend gate exactly:
// CAPABILITY_MATRIX['delete_calls'] = ['super_admin', 'admin'] in
// api/src/index.ts, which in turn is reached via canonicalRoleClient()'s
// role canonicalization (src/lib/permissions/labels.ts / App.tsx's local
// copy). Only the super_admin and admin canonical tiers may delete calls —
// office, salesperson (including the legacy 'estimator' job-title string),
// accounting, vendor, and any unmapped/other role are denied, matching the
// server 403 exactly so the button never lies about what the API will allow.
//
// Keep this in lockstep with the backend CAPABILITY_MATRIX['delete_calls']
// entry — if that role list ever changes, update this function too.

export interface CallPermissionUser {
  role?: string | null
  is_admin?: boolean | number | null
}

function isAdminFlag(value: boolean | number | null | undefined): boolean {
  if (value === true) return true
  if (typeof value === 'number') return value === 1
  return false
}

/** True only for the super_admin / admin canonical tiers — the same roles
 *  the server-side delete_calls capability admits. False for null/undefined
 *  users, so an unresolved identity fails closed (no Delete affordance). */
export function canDeleteCalls(user: CallPermissionUser | null | undefined): boolean {
  if (!user) return false
  if (isAdminFlag(user.is_admin)) return true
  const role = (user.role || '').toLowerCase().trim()
  if (role === 'super admin' || role === 'super_admin' || role === 'super-admin' || role === 'superadmin') return true
  if (role === 'owner') return true
  if (role === 'admin' || role === 'vp' || role === 'consultant') return true
  return false
}
